import { useEffect, useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { API } from "@/lib/api";

export function AISummary({ id }) {
  const [text, setText] = useState("");
  const [status, setStatus] = useState("loading");
  useEffect(() => {
    const es = new EventSource(`${API}/news/${id}/summary`);
    es.onmessage = (e) => {
      if (e.data === "[DONE]") { es.close(); setStatus((s) => (s === "error" ? s : "done")); return; }
      const d = JSON.parse(e.data);
      if (d.error) { setStatus("error"); setText(d.error); return; }
      setText((t) => t + d.t);
    };
    es.onerror = () => { es.close(); setStatus((s) => (s === "loading" ? "error" : s)); };
    return () => es.close();
  }, [id]);
  const points = text.split("\n").map((l) => l.replace(/^[•\-*\d.\s]+/, "").trim()).filter(Boolean);
  return (
    <div data-testid="ai-summary-box" className="rise my-8 rounded-2xl border border-primary/30 bg-primary/[0.05] p-6">
      <div className="mb-4 flex items-center gap-2 font-mono-meta text-[11px] font-bold uppercase tracking-widest text-primary">
        {status === "loading" ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />} Resumo em 3 pontos · IA
      </div>
      {status === "error" ? <p className="text-sm text-muted-foreground">{text || "Não foi possível gerar o resumo."}</p> : (
        <ul className="space-y-3">
          {points.map((p, i) => (
            <li key={i} className="flex gap-3 text-[15px] font-medium leading-relaxed">
              <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-primary text-xs font-black text-white">{i + 1}</span>{p}
            </li>
          ))}
          {!points.length && <li className="text-sm text-muted-foreground">A ler a notícia…</li>}
        </ul>
      )}
    </div>
  );
}
